import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemSelectionClass } from '../../../../../core/services/menu/menu-item-selection.service';
import { IComponentController, IFormController, IScope } from 'angular';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IApiConfig } from '../../../../../core/interfaces/api-config.interface';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemClass } from '../../../../../core/services/menu/menu-item.service';
import { IDownloadManagerService } from '../../../../../core/services/download-manager.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMenuItemImportationExcelClass } from '../../../../../core/services/menu/menu-item-importation-excel.service';
import { IEcranContextController } from '../../../../../core/behaviors/ex-ecran-context/ex-ecran-context.behavior';

interface IPageDo0064 extends IComponentController {
    ecranContextCtrl: IEcranContextController;
    ofaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formCtrl: IFormController;
    criteresSuggeres: any;
    valeursEcran: any;
    paramsNouveau: any
}

interface IDo0064Params {
    menuId: string
    unocleint: number
    trmcleint: number
    ofacleint: number
    unocleintrh: number
    isforage: number
}

/* @ngInject */
export default function Do0064Controller(
    Formulaire: IFormulaireClass,
    ApiConfig: IApiConfig,
    Menu: IMenuClass,
    MenuItemSelection: IMenuItemSelectionClass,
    FormulaireItemDivider: IFormulaireItemDividerClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    MenuItem: IMenuItemClass,
    downloadManager: IDownloadManagerService,
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemAction: IMenuItemActionClass,
    $scope: IScope,
    $stateParams: IDo0064Params,
    do0068Route: IRoute,
    MenuItemImportationExcel: IMenuItemImportationExcelClass
) {
    const vm: IPageDo0064 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.monoOccurrenceOptions = {
        noId: true,
    }

    function normalizePortalMenuUrl(url: string) {
        return url
            .replace('localhost:8080', 'localhost:3000')
            .replace(/\/api(?=\/)/i, '/frontend')
            .replace(/\/safirh2\/frontend(?=\/|$)/i, '/safirh2')
            .replace(/\/safirh\/accueil(?=\/|$)/i, '/portail-employe/menu')
            .replace(/^\/menu(?=\/portail-employe\/menu)/i, '')
            .replace(/(?:\/portail-employe\/menu)+/g, '/portail-employe/menu');
    }

    function getPortalHostBaseUrl() {
        const configuredBaseUrl = (ApiConfig && ApiConfig.URL) ? ApiConfig.URL.trim().replace(/\/+$/, '') : '';
        if (!configuredBaseUrl) return window.location.origin;

        if (/^https?:\/\//i.test(configuredBaseUrl)) return normalizePortalMenuUrl(configuredBaseUrl);
        if (configuredBaseUrl.startsWith('/')) return normalizePortalMenuUrl(`${window.location.origin}${configuredBaseUrl}`);

        return normalizePortalMenuUrl(`${window.location.origin}/${configuredBaseUrl}`);
    }

    function getPortalBasePath() {
        const baseUrl = getPortalHostBaseUrl();
        if (/\/portail-employe\/menu(?=\/|$)/i.test(baseUrl)) return baseUrl;
        return `${baseUrl}/portail-employe/menu`;
    }

    function getPortalDeploymentRoot() {
        return getPortalBasePath().replace(/\/portail-employe\/menu(?=\/|$).*/i, '');
    }

    function resolvePortalUrl(url: string) {
        if (!url) return '';

        const rawUrl = normalizePortalMenuUrl(url.trim());
        if (/^https?:\/\//i.test(rawUrl)) return rawUrl;
        if (/^\/portail-employe\/menu(?=\/|$)/i.test(rawUrl)) return `${getPortalDeploymentRoot()}${rawUrl}`;
        if (rawUrl.startsWith('/')) return `${window.location.origin}${rawUrl}`;

        return `${getPortalDeploymentRoot()}/${rawUrl.replace(/^\/+/, '')}`;
    }

    function hasValue(value: any): boolean {
        return value !== undefined && value !== null && value !== '';
    }

    function canImport(): boolean {
        const criteres = vm.multiOccurrence?.etatSelected?.criteresSuggeresData;

        return Boolean(
            hasValue(criteres?.punocleint) &&
            hasValue(criteres?.ptrmcleint)
        );
    }

    const criteresSuggeres = new Formulaire([
        new FormulaireItem('punocleint', {
            largeur: 30,
            required: true
        }),
        new FormulaireItem('ptrmcleint', {
            largeur: 30,
            required: true
        }),
        new FormulaireItem('ptemcleint', {
            ignoreEtat: true,
            largeur: 30
        }),
        new FormulaireItemDivider('LBL_CRI_EMP', { hidden: true }),   // Emplois
    ]);
    const isForage = Number($stateParams?.isforage) === 1;

    vm.multiOccurrenceOptions = {
        bloc: 'OFA',
        criteresSuggeres: criteresSuggeres,
        fonctions: {
            rechercheCollapsable: false,
            importation: false,
            nouveau: () => canImport(),
            supprime: (rowData: any) => rowData.nbrcand === 0,
            reinitialiserOuvrirCriteres: !isForage,
            effaceCriteres: true,
            boutonDupliquer: true,
            criteresSuggeresVisibles: !isForage,
            forcerCriteresSuggeresFermes: isForage,
        },
        actionsMore: new Menu([
            new MenuItemImportationExcel(vm.ecranContextCtrl, {
                disabled: () => !canImport(),
                class: () => `do0064-importation ${!canImport() ? 'do0064-importation-disabled' : ''}`,
                blocImportation: 'OFA'
            }),
            new MenuItem('TELECHARGER_PATRON', () => {
                downloadManager.directDownload('/do0064/patron', {}, $stateParams, ecranDetails);
            }, {
                icon: 'file_download'
            })
        ]),
        actionsMoreLigne: new Menu([
            new MenuItemAction(
                'G_LBL_APERCU',
                'BOUURLPOR',
                (rowData: any) => ({
                    ofacleint: rowData.ofacleint,
                    urlbas: getPortalBasePath()
                }),
                {
                    icon: 'visibility',
                    iconButton: false,
                    successAction(response) {
                        const url = resolvePortalUrl(response?.url);
                        if (url) {
                            window.open(url, '_blank');
                        }
                    }
                }
            ),
        ]),
        navigatePage: () => do0068Route.NAME,
        navigateParams: (rowData: any) => ({
            trmcleint: vm?.multiOccurrence?.etatSelected?.criteresSuggeresData?.ptrmcleint,
            unocleint: vm?.multiOccurrence?.etatSelected?.criteresSuggeresData?.punocleint,
            temcleint: vm?.multiOccurrence?.etatSelected?.criteresSuggeresData?.ptemcleint,
            isforage: 1
        }),
        colonnesFixesGauche: [
            { nom: 'ofanum', largeur: 150 },
            { nom: 'crscod', largeur: 120 },
            { nom: 'crsdsc', largeur: 300 },
            { nom: 'cofgrp', largeur: 100 },
            { nom: 'temcod', largeur: 140 }
        ],
        colonnesVisibles: [
            { nom: 'temdscabr', largeur: 220 },
            { nom: 'ofanbrcan', largeur: 100 },
            { nom: 'ofanbrhre', largeur: 110 },
            { nom: 'litcod', largeur: 110 },
            { nom: 'litdsc', largeur: 180 },
            { nom: 'ofaflgpub', largeur: 90 },
            { nom: 'ofahrelim', largeur: 150 },
            { nom: 'ofadatdeb', largeur: 110 },
            { nom: 'ofadatfin', largeur: 110 },
            { nom: 'eplnummat', largeur: 130 },
            { nom: 'eplnomprn', largeur: 180 },
            { nom: 'ofainfadd', largeur: 500 },
            { nom: 'ofadscexi', largeur: 400 },
            { nom: 'ofaadrcou', largeur: 260 },
            { nom: 'eplnummatsuv', largeur: 130 },
            { nom: 'eplnomprnsuv', largeur: 180 }
        ],
        actionsSelection: new Menu([
            new MenuItemSelection(
                'LBL_BTN_PUBLIER',
                'BOUPUB',
                {
                    selection: { nom: 'publier' },
                    successAction: () => {
                        vm.multiOccurrence && vm.multiOccurrence.fetchDataList();
                    },
                    fonction: 'BOUPUB'
                })
        ]),
        formulaire: new Formulaire([
            new FormulaireItem('unocleintrh', { hidden: true, default: () => vm.multiOccurrence.etatSelected.criteresSuggeresData.punocleint }),
            new FormulaireItem('trmcleint', { hidden: true, default: () => vm.multiOccurrence.etatSelected.criteresSuggeresData.ptrmcleint }),
            new FormulaireItem('crscleint', {
                largeur: 31, resourceParams: (data: any) => ({ unocleintrh: data.unocleintrh, trmcleint: data.trmcleint })
            }),
            new FormulaireItem('cofcleint', {
                largeur: 34, resourceParams: (data: any) => ({ crscleint: data.crscleint, trmcleint: data.trmcleint })
            }),
            new FormulaireItem('temcleint', { largeur: 31 }),
            new FormulaireItem('ofanbrhre', { largeur: 11 }),
            new FormulaireItem('ofanbrcan', { largeur: 11, default: 1 }),
            new FormulaireItem('litcleint', { largeur: 32 }),
            new FormulaireItem('ofahrelim', { largeur: 25 }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('ofadatdeb', { largeur: 10, default: (data: any) => data.ofadatdeb }),
            new FormulaireItem('ofadatfin', { largeur: 10, default: (data: any) => data.ofadatfin }),
            new FormulaireItem('demcleint', {
                largeur: 31,
                resourceParams: (!$stateParams?.isforage) ? (data: any) => ({ ofacleint: data.ofacleint, ofadatdeb: data.ofadatdeb, ofadatfin: data.ofadatfin }) : undefined,
                disabled: (data: any) => !data.ofadatdeb
            }),
            new FormulaireItem('demcleintsuv', {
                largeur: 31,
                resourceParams: (!$stateParams?.isforage) ? (data: any) => ({ ofacleint: data.ofacleint, ofadatdeb: data.ofadatdeb, ofadatfin: data.ofadatfin }) : undefined,
                disabled: (data: any) => !data.ofadatdeb
            }),
            new FormulaireItem('ofaadrcou', { largeur: 30, historiqueColonne: true }),
            new FormulaireItem('ofainfadd', { largeur: 66 }),
            new FormulaireItem('ofadscexi', { largeur: 66 }),
            new FormulaireItem('ofaflgpub', { largeur: 15 })
        ]),
        colonnesCachees: [
            'unocleintrh',
            'trmcleint',
            'ofacleint',
            'nbrcand',
            'isforage'
        ]
    };

    $scope.$watch('vm.multiOccurrence.etatSelected.criteresSuggeresData.punocleint', (newValue) => {
        if (newValue) {
            vm.multiOccurrence.etatSelected.criteresSuggeresData.punocleint = newValue;
            vm.multiOccurrence.etatSelected.criteresSuggeresData.unocleintrh = newValue;
            let formulaireItem = (vm?.criteresSuggeres?.liste || []).find((l: any) => l.col === 'punocleint');
            if (formulaireItem) {
                formulaireItem.required = true;
                formulaireItem.supprimable = false;
            }

            vm.paramsNouveau = {
                ...vm.paramsNouveau,
                unocleintrh: newValue,
            }
            vm.multiOccurrence.emit('etatUpdate');
        }
    });

    $scope.$watch('vm.multiOccurrence.etatSelected.criteresSuggeresData.ptrmcleint', (newValue) => {
        if (newValue) {
            vm.multiOccurrence.etatSelected.criteresSuggeresData.ptrmcleint = newValue;
            vm.multiOccurrence.etatSelected.criteresSuggeresData.trmcleint = newValue;
            let formulaireItem = (vm?.criteresSuggeres?.liste || []).find((l: any) => l.col === 'ptrmcleint');
            if (formulaireItem) {
                formulaireItem.required = true;
                formulaireItem.supprimable = false;
            }
            vm.paramsNouveau = {
                ...vm.paramsNouveau,
                trmcleint: newValue
            }
            vm.multiOccurrence.emit('etatUpdate');
        }
    });
}
